<template>
  <div>
    <h2 class="text-gray-500 text-xs font-medium uppercase tracking-wide">Linked Accounts</h2>
    <ul class="mt-2 space-y-2">
      <template v-if="linkedAccounts.length">
        <li v-for="linkedAccount in linkedAccounts" :key="linkedAccount.id">
          <LinkedAccountListItem
            :account="linkedAccount"
            :on-unlink-account="handleUnlinkAccount"
          />
        </li>
      </template>
      <li v-else>
        <div class="py-4 px-3 border-2 border-dashed border-gray-400 rounded">
          <div class="flex items-center space-x-4">
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-teal-900 text-center">
                There is no linked account.
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { facebookPageAccountsClient } from '@/api/clients/admin';
import LinkedAccountListItem from './LinkedAccountListItem.vue';

export default {
  components: {
    LinkedAccountListItem,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    linkedAccounts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleUnlinkAccount(account) {
      return facebookPageAccountsClient.destroy(this.page.id, account.id).then(() => {
        this.$emit('changed');
        return Promise.resolve();
      });
    },
  },
};
</script>
